export default __webpack_public_path__ + "static/media/screen3.a97cea16.jpg";